import { PERMISSION } from '@/constants/permission.constant';

const FuelTypeList = () => import('@/views/configuration/fuel-types/List.vue');
const FuelTypeAdd = () => import('@/views/configuration/fuel-types/Add.vue');
const FuelTypeEdit = () => import('@/views/configuration/fuel-types/Edit.vue');

export const FuelTypeRoute = [
  {
    path: '/configuration/fuel-types',
    name: 'FuelType',
    component: FuelTypeList,
    meta: { requiresAuth: false, permissions: [PERMISSION.FULE_TYPE_READ] },
  },

  {
    path: '/configuration/fuel-types/create',
    name: 'fuel-type-create',
    component: FuelTypeAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.FULE_TYPE_CREATE] },
  },
  {
    path: '/configuration/fuel-types/:id/edit',
    name: 'fuel-type-edit',
    component: FuelTypeEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.FULE_TYPE_UPDATE] },
  },
];
